import { is } from '../is.js';

export { addTransitions };

/**
 * Describe transition applied to slides.
 *
 * @typedef {object} TransitionDescription
 * @property {string} name
 * @property {{[key:(appear|enter|exit)]: number}} duration
 * @property {{[key:(appear|enter|exit)]: number}} delay
 * @property {{[key:(appear|enter|exit)]: string}} timingFunction
 * @property {[string, (string|number)[]][]} rules
 */

/**
 * @type {TransitionDescription}
 * */
const popupFade = {
  name: 'popup-fade',
  duration: deNormalizeStages([1000, 300]),
  timingFunction: deNormalizeStages('ease-in-out'),
  rules: [['opacity', [0.01, 1.01, 0.01]]],
  delay: deNormalizeStages([0, 50]),
};

/**
 *
 * @type {TransitionDescription}
 */
const fullscreenFade = {
  name: 'fullscreen-fade',
  duration: deNormalizeStages([500, 500]),
  timingFunction: deNormalizeStages(['ease', 'ease-in-out']),
  rules: [['opacity', [0.01, 1.01, 0.01]]],
  delay: deNormalizeStages([0, 100]),
};

/**
 * Inject into schema slide's transition description.
 *
 * Add minimal necessary to every slide for rendering and
 * list of used transition for generation css rules.
 *
 * @see generateStyles#transitionsRules
 * @param schema
 * @return {RawCreativeSchema & {transitions: TransitionDescription[]}}
 */
function addTransitions(schema) {
  schema.slides.forEach((slide) => {
    const transition = is.slideDisplayMode.standard(slide)
      ? popupFade
      : fullscreenFade;
    const { name, duration, delay } = transition;
    slide.transition = {
      name,
      timeout: {
        appear: duration.enter + delay.enter,
        enter: duration.enter + delay.enter,
        exit: duration.exit + delay.exit,
      },
    };
  });

  schema.transitions = [popupFade, fullscreenFade];
  return schema;
}

function deNormalizeStages(values) {
  const [enter, exit] = Array.isArray(values) ? values : [values, values];
  return {
    enter,
    exit,
  };
}
